// Variant Title Shortening Functionality
// This script handles dynamic shortening of variant titles to 19 characters with ellipses

(function() {
    // Global initialization flag to prevent duplicate execution
    if (window.variantTitleShorteningInitialized) return;
    window.variantTitleShorteningInitialized = true;

    const SHORTEN_MATCHES = ['Standard', 'Whole Foods Compliant', 'Wholefoods Compliant'];
    const MAX_LENGTH = 18;

    function shouldShorten(fullTitle) {
        return !!fullTitle && fullTitle.length > MAX_LENGTH &&
            SHORTEN_MATCHES.some(function (match) { return fullTitle.includes(match); });
    }

    // Function to truncate selected option for a given select element
    function truncateSelectedOption(select) {
        try {
            const selectedOption = select.options[select.selectedIndex];
            if (!selectedOption) return;

            const fullTitle = selectedOption.getAttribute('data-full-title');
            if (shouldShorten(fullTitle)) {
                const shortenedTitle = fullTitle.substring(0, MAX_LENGTH) + '...';
                const pricePart = selectedOption.textContent.includes(' - ') ? selectedOption.textContent.split(' - ')[1] : '';
                selectedOption.textContent = shortenedTitle + (pricePart ? ' - ' + pricePart : '');
            }
        } catch (error) {
            console.error('Error in truncateSelectedOption:', error);
        }
    }

    // Function to restore all options to full titles for a given select element
    function restoreAllOptions(select) {
        try {
            for (let i = 0; i < select.options.length; i++) {
                const option = select.options[i];
                const fullTitle = option.getAttribute('data-full-title');
                if (shouldShorten(fullTitle)) {
                    const pricePart = option.textContent.includes(' - ') ? option.textContent.split(' - ')[1] : '';
                    option.textContent = fullTitle + (pricePart ? ' - ' + pricePart : '');
                }
            }
        } catch (error) {
            console.error('Error in restoreAllOptions:', error);
        }
    }

    // Function to setup variant select functionality
    function setupVariantSelect(select) {
        if (select.dataset.variantShorteningInitialized) return;

        let dropdownOpen = false;

        // Handle change event - truncate the newly selected option
        select.addEventListener('change', function() {
            restoreAllOptions(this);
            truncateSelectedOption(this);
        });

        // Handle mousedown - this fires when dropdown opens
        select.addEventListener('mousedown', function() {
            dropdownOpen = true;
            restoreAllOptions(this);
        });

        // Handle click outside to detect when dropdown closes
        document.addEventListener('click', function(e) {
            if (!select.contains(e.target)) {
                if (dropdownOpen) {
                    dropdownOpen = false;
                    truncateSelectedOption(select);
                }
            }
        });

        // Initial truncation of selected option
        truncateSelectedOption(select);

        // Mark as initialized
        select.dataset.variantShorteningInitialized = 'true';
    }

    // Function to initialize all variant selects
    function initializeVariantSelects() {
        document.querySelectorAll('.variant-select').forEach(function (select) {
            if (select.dataset.variantShorteningInitialized) {
                restoreAllOptions(select);
                truncateSelectedOption(select);
            } else {
                setupVariantSelect(select);
            }
        });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeVariantSelects);
    } else {
        initializeVariantSelects();
    }

    // For dynamic content (like cart updates), we need to re-initialize
    // This will be called from specific sections that need it
    window.reinitializeVariantTitleShortening = function() {
        initializeVariantSelects();
    };

    document.addEventListener('cart:updated', function () {
        setTimeout(initializeVariantSelects, 100);
    });
    document.addEventListener('theme:loading:end', function () {
        setTimeout(initializeVariantSelects, 100);
    });

    // MutationObserver for dynamic content (like search results)
    const observer = new MutationObserver(function(mutations) {
        let shouldReinitialize = false;
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                for (let i = 0; i < mutation.addedNodes.length; i++) {
                    const node = mutation.addedNodes[i];
                    if (node.nodeType === 1) {
                        if (node.matches && node.matches('.variant-select')) {
                            shouldReinitialize = true;
                            break;
                        }
                        if (node.querySelectorAll && node.querySelectorAll('.variant-select').length > 0) {
                            shouldReinitialize = true;
                            break;
                        }
                    }
                }
            }
        });

        if (shouldReinitialize) {
            setTimeout(function () {
                initializeVariantSelects();
            }, 100);
        }
    });

    // Start observing
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

})();
